export default Object.freeze({
  UNSET: 0,
  ADDITIONAL_INFORMATION: 1,
  DOCUMENTS: 2,
  ACCEPT: 3,
  REJECT: 4,
  HISTORY_REQUEST: 5,
  AEE_REQUEST: 6,
  REVERT: 7,
});
